import React from 'react';
import { NotificationRule } from '../../../sp-types/notificationRule';
import { notifRuleDescriptions } from './NotifRulesUtils';
import { Input, Button, MenuItem, Select } from '@mui/material';
import { CloseButton } from '../../../components/UI-Elements/Buttons/CloseButton';

export const EditNotifRule: React.FC<{
  rule: NotificationRule;
  updateRule: (_rule: NotificationRule) => void;
  close: () => void;
}> = ({ rule, updateRule, close }) => {
  const [editRule, setEditRule] = React.useState<NotificationRule | undefined>(rule);

  const saveEditRule = (rule: NotificationRule) => {
    updateRule(rule);
    setEditRule(undefined);
    close();
  };

  return (
    editRule && (
      <div className="flex flex-col p-4 gap-4 bg-white rounded shadow-custom w-[50rem] h-96">
        <div className="flex justify-between font-semibold">
          Rule details: {editRule.name} <CloseButton onClick={close} />
        </div>
        <div className="font-semibold">Description</div>
        <div className="">
          {notifRuleDescriptions[editRule.type] ||
            'This rule monitors specific conditions and triggers notifications based on your settings.'}
        </div>
        <div className="font-semibold">Conditions</div>
        {['backwardation', 'contango'].includes(editRule.type || '') && (
          <div className="flex gap-2">
            Current price is
            <Input
              sx={{ color: 'blue' }}
              className="w-16 border"
              type="number"
              value={editRule.condition || 20}
              onChange={({ target }) => setEditRule({ ...editRule, condition: target.value })}
            />
            <Select
              sx={{ color: 'blue' }}
              className="w-13 h-8 border"
              value={editRule.options?.conditionType || '$'}
              onChange={({ target }) =>
                setEditRule({ ...editRule, options: { ...editRule.options, conditionType: target.value } })
              }
            >
              <MenuItem value="$">$</MenuItem>
              <MenuItem value="%">%</MenuItem>
            </Select>
            /mt higher then next:
            <Input
              sx={{ color: 'blue' }}
              className="w-10 border"
              type="number"
              value={editRule.options?.compareMonth || 1}
              onChange={({ target }) =>
                setEditRule({ ...editRule, options: { ...editRule.options, compareMonth: target.value } })
              }
            />
            months future contract
          </div>
        )}
        {['price_target'].includes(editRule.type || '') && (
          <div className="flex gap-2">
            Current price is
            <Input
              sx={{ color: 'blue' }}
              className="w-16 border"
              type="number"
              value={editRule.condition || 20}
              onChange={({ target }) => setEditRule({ ...editRule, condition: target.value })}
            />
            <Select
              sx={{ color: 'blue' }}
              className="w-13 h-8 border"
              value={editRule.options?.conditionType || '$'}
              onChange={({ target }) =>
                setEditRule({ ...editRule, options: { ...editRule.options, conditionType: target.value } })
              }
            >
              <MenuItem value="$">$</MenuItem>
              <MenuItem value="%">%</MenuItem>
            </Select>
            /mt higher\lower then:
            <Input
              sx={{ color: 'blue' }}
              className="w-10 border"
              type="number"
              value={editRule.options?.compareDays || 1}
              onChange={({ target }) =>
                setEditRule({ ...editRule, options: { ...editRule.options, compareDays: target.value } })
              }
            />
            days ago
          </div>
        )}
        {['balance_limit'].includes(editRule.type || '') && (
          <div className="flex gap-2">
            Current balance is
            <Input
              sx={{ color: 'blue' }}
              className="w-16 border"
              type="number"
              value={editRule.condition || 20}
              onChange={({ target }) => setEditRule({ ...editRule, condition: target.value })}
            />
            away from target
          </div>
        )}
        <div className="flex gap-4 justify-end ">
          <Button onClick={close} variant="outlined">
            Cancel
          </Button>
          <Button variant="contained" onClick={() => saveEditRule({ ...editRule })}>
            Save
          </Button>
        </div>
      </div>
    )
  );
};
